export const STATUS_PENDING = 'pending'
export const STATUS_APPROVED = 'approved'
export const STATUS_REJECTED = 'rejected'

export const APPROVAL_STATUS_META = {
  [STATUS_PENDING]: {
    key: STATUS_PENDING,
    title: 'Не ответили',
    label: 'Ожидает',
    empty: 'Нет ожидающих ответ',
    variant: 'warning',
  },
  [STATUS_APPROVED]: {
    key: STATUS_APPROVED,
    title: 'Согласовали',
    label: 'Согласовано',
    empty: 'Пока никто не согласовал',
    variant: 'success',
  },
  [STATUS_REJECTED]: {
    key: STATUS_REJECTED,
    title: 'Отклонили',
    label: 'Отклонено',
    empty: 'Отклонений нет',
    variant: 'danger',
  },
}

const BUDGET_STATUS_META = {
  'новый': { label: 'Новый', variant: 'draft' },
  'в согласовании': { label: 'В согласовании', variant: 'review' },
  'согласован': { label: 'Согласован', variant: 'success' },
}

export function normalizeApprovalStatus(status) {
  const normalized = String(status || '').toLowerCase().trim()
  if (normalized === STATUS_APPROVED) return STATUS_APPROVED
  if (normalized === STATUS_REJECTED) return STATUS_REJECTED
  return STATUS_PENDING
}

export function getApprovalStatusMeta(status) {
  return APPROVAL_STATUS_META[normalizeApprovalStatus(status)] || APPROVAL_STATUS_META[STATUS_PENDING]
}

export function splitApprovalsByStatus(approvals = []) {
  return (approvals || []).reduce((groups, approval) => {
    const status = normalizeApprovalStatus(approval?.status)
    groups[status].push(approval)
    return groups
  }, {
    [STATUS_PENDING]: [],
    [STATUS_APPROVED]: [],
    [STATUS_REJECTED]: [],
  })
}

export function buildApprovalSummary(approvals = [], budgetStatus = 'новый') {
  const groups = splitApprovalsByStatus(approvals)
  const total = approvals.length
  const approvedCount = groups[STATUS_APPROVED].length
  const pendingCount = groups[STATUS_PENDING].length
  const rejectedCount = groups[STATUS_REJECTED].length
  const progressPercent = total > 0 ? Math.round((approvedCount / total) * 100) : 0
  const statusMeta = BUDGET_STATUS_META[String(budgetStatus || 'новый').toLowerCase().trim()] || BUDGET_STATUS_META['новый']

  return {
    total,
    approvedCount,
    pendingCount,
    rejectedCount,
    progressPercent,
    budgetStatusLabel: statusMeta.label,
    budgetStatusVariant: statusMeta.variant,
  }
}

export function getApproverInitials(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean)
  if (!parts.length) return '—'
  return parts.slice(0, 2).map((part) => part[0]?.toUpperCase()).join('')
}

export function contractSubtitle(contract) {
  return [contract?.number, contract?.client_name, contract?.object_name]
    .filter(Boolean)
    .join(' · ')
}
